<ion-grid>
    <ion-row>
        <ion-col size="12">
            <app-nonbooking-payment [application]="status?.application"> </app-nonbooking-payment>
        </ion-col>
    </ion-row>
    <ion-toolbar>
        <!-- binding value to ensure document pane is highlighted on load -->
        <ion-segment (ionChange)="segmentChanged($event)" [value]="reserved?.view" mode="md">
            <ion-segment-button value="document" checked mode="md">
                <ion-label class="segment-label">
                    {{ (toolService.content | async)?.application?.components?.reserved?.segmentbuttons?.application }}</ion-label
                >
            </ion-segment-button>
            <ion-segment-button value="program" mode="md">
                <ion-label class="segment-label"> {{ (toolService.content | async)?.application?.components?.reserved?.segmentbuttons?.program }}</ion-label>
            </ion-segment-button>
        </ion-segment>
    </ion-toolbar>
    <div [ngSwitch]="reserved?.view">
        <div *ngSwitchCase="'document'">
            <ion-row>
                <ion-col class="ion-text-center">
                    <div style="margin: 1rem">
                        <ion-label class="sub-title" color="dark-teal">
                            {{ (toolService.content | async)?.application?.components?.reserved?.segmentbuttons?.uploaddocuments }}
                            <!-- <ion-button type="button" (click)="test()">T</ion-button> -->
                        </ion-label>
                    </div>
                </ion-col>
            </ion-row>
            <app-general-documents [status]="status"></app-general-documents>
        </div>
        <div *ngSwitchCase="'program'">
            <app-program-summary [program]="status?.application?.program" [application]="status?.application"> </app-program-summary>
        </div>
    </div>
    <ion-row
        *ngIf="
            (status?.application?.program?.requiredpostdocumentlist?.requireContract && status?.application?.signedcontract) ||
            (status?.application?.program?.requiredpostdocumentlist?.default && status?.application?.signedcontract) ||
            (!status?.application?.program?.requiredpostdocumentlist?.requireContract && status?.application?.signedcontract)
        "
    >
        <ion-col size="12">
            <div class="title-section">
                <div class="title-container">
                    <ion-label class="title"> {{ (toolService.content | async)?.application?.components?.reserved?.requrestenrollment }}</ion-label>
                </div>
            </div>
        </ion-col>
        <ion-col size="12">
            <div
                [ngClass]="
                    submittingEnrollmentCheck
                        ? 'circle-container-pending'
                        : status?.application?.enrollable
                        ? 'circle-container-pending'
                        : (enrollment$ | async)
                        ? 'circle-container-ready'
                        : 'circle-container'
                "
                (click)="requestEnrollment()"
            >
                <div class="circle">
                    <div class="circle-content">
                        <div>
                            <fa-icon *ngIf="!submittingEnrollmentCheck" slot="start" [icon]="faUserMd" size="3x"></fa-icon>
                            <ion-spinner *ngIf="submittingEnrollmentCheck" class="enrollment-spinner" name="lines" color="light"></ion-spinner>
                        </div>
                        <div *ngIf="status?.application?.enrollable && !submittingEnrollmentCheck">Your enrollment request is under review</div>
                        <div
                            *ngIf="!status?.application?.enrollable && !submittingEnrollmentCheck"
                            [innerHTML]="(toolService.content | async)?.application?.components?.reserved?.enrollButton"
                        ></div>
                    </div>
                </div>
            </div>
            <div tappable (click)="requestEnrollment()" class="center-block">
                <br />
                <a class="link-anchor-base">{{ (toolService.content | async)?.application?.components?.reserved?.cantenroll }}</a>
                <br /><br />
            </div>
        </ion-col>
    </ion-row>
</ion-grid>
